import { Map as ImmutableMap, Record } from 'immutable';
import TagRecord from './TagRecord';
const TagsRecord = Record({
  // @ts-expect-error ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
  data: new ImmutableMap(),
  lastLoaded: undefined,
  loadError: null,
  isRequesting: false
});
TagsRecord.fromTags = tags => new TagsRecord({
  // @ts-expect-error ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
  data: new ImmutableMap(tags.map(tag => [tag.id, new TagRecord(tag)]))
});
export default TagsRecord;